<template>
  <div class="contents">
    <top>
      <el-button v-hasPermi="['customer:invite:send']" type="primary" icon="el-icon-plus"
        @click="onInviteMember">邀请成员</el-button>
    </top>
    <div class="member-list">
      <div class="search">
        <div class="search_l">
          <el-select @change="getMemberList(1)" v-model="queryParams.roleId" prefix-icon="el-icon-search"
            style="margin-right: 10px" size="small" clearable placeholder="角色">
            <el-option label="管理员" :value="0"> </el-option>
            <el-option label="普通成员" :value="1"> </el-option>
          </el-select>
          <el-select @change="getMemberList(1)" v-model="queryParams.status" prefix-icon="el-icon-search" size="small"
            clearable placeholder="在线状态" placeholder-class="placeholder_text">
            <el-option label="在线" :value="1"> </el-option>
            <el-option label="离线" :value="0"> </el-option>
          </el-select>
        </div>
        <div class="search_r">
          <el-input @change="getMemberList(1)" placeholder="请输入成员昵称" prefix-icon="el-icon-search" size="small" clearable
            v-model="queryParams.nickName">
          </el-input>
        </div>
      </div>
      <div class="table_box">
        <el-table :data="memberList" v-loading="loading" height="100%">
          <el-table-column label="成员信息" prop="nickName" width="160px">
            <template #default="scope">
              <div class="member-name-cell">
                <span class="member-name-text" :title="scope.row.nickName">{{ scope.row.nickName }}</span>
                <!-- 负责人可改本团队其他成员名字；改自己走个人中心，故不显示。图标 flex 固定，避免长昵称把它挤出单元格点不到 -->
                <i v-if="isAdmin && scope.row.userId != userInfo.id" class="el-icon-edit edit-name-icon"
                  title="修改名称" @click="onRename(scope.row)"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="邮箱" show-overflow-tooltip prop="userName" width="160px"></el-table-column>
          <el-table-column label="角色" prop="roleName"></el-table-column>
          <el-table-column label="在线状态" prop="status">
            <template #default="scope">
              <el-tag v-if="scope.row.status == 1" type="success" size="small">在线</el-tag>
              <el-tag v-else type="danger" size="small">离线</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="分配标识" show-overflow-tooltip prop="uuid"></el-table-column>
          <el-table-column label="客服链接" width="300px">
            <template #default="scope">
              <div v-if="scope.row.uuid" class="link-box">
                <a class="link" :href="`${baseUrl}?token=${scope.row.uuid}`" target="_blank">{{
                  `${baseUrl}?token=${scope.row.uuid}`
                  }}</a>
                <i @click="copyText(`${baseUrl}?token=${scope.row.uuid}`)" class="el-icon-document-copy link-copy"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130px">
            <template #default="scope">
              <el-link v-hasPermi="['customer:link:issue']" type="primary" :underline="false"
                @click="handleUpdate(scope.row)">{{ scope.row.uuid ? "重置链接" : "生成链接" }}</el-link>
              <el-link v-hasPermi="['customer:link:delete']" v-if="scope.row.userId != userInfo.id" type="danger" :underline="false"
                @click="handleDelete(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table-pagination">
        <el-pagination background class="penye" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="邀请成员" :visible.sync="isInvite" width="28%">
      <el-form ref="InviteMember" :model="formInvite" :rules="rules">
        <div class="topInvite">
          <el-link v-if="type == 1" type="primary" :underline="false" @click="type = 2">批量邀请</el-link>
          <el-link v-else type="primary" :underline="false" @click="type = 1">单个邀请</el-link>
        </div>
        <el-form-item label="邮箱" prop="targetUser">
          <el-input v-if="type == 1" type="text" v-model="formInvite.targetUser" size="small"></el-input>
          <el-input v-else type="textarea" v-model="formInvite.targetUser" placeholder="批量邀请请用英文逗号隔开"
            size="small"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="formInvite.roleId" style="width: 100%" size="small" disabled placeholder="请选择">
            <el-option label="管理员" :value="0"></el-option>
            <el-option label="普通用户" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isInvite = false">取 消</el-button>
        <el-button type="primary" @click="ok()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改成员名称" :visible.sync="renameVisible" width="28%">
      <el-form ref="renameForm" :model="renameForm" :rules="renameRules">
        <el-form-item label="名称" prop="nickName">
          <el-input v-model="renameForm.nickName" size="small" maxlength="30" show-word-limit
            placeholder="请输入成员名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renameVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRename()">确 定</el-button>
      </span>
    </el-dialog>
    <sub-dialog :visible="subdialogvis"></sub-dialog>
  </div>
</template>
<script>
import top from "./components/top.vue";
export default {
  data() {
    return {
      loading: false,
      baseUrl: process.env.VUE_APP_KEFU_URL,
      memberList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        nickName: null,
        isBanned: null,
        roleId: null,
        status: null,
      },
      total: 0,
      renameVisible: false,
      renameForm: { userId: null, nickName: "" },
      renameRules: {
        nickName: [{ required: true, message: "请输入成员名称", trigger: "blur" }],
      },
      isInvite: false,
      type: 1,
      formInvite: {
        targetUser: "",
        roleId: 1,
      },
      rules: {
        targetUser: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getMemberList();
  },
  computed: {
    roles() {
      return this.$store.state.userStore.roles;
    },
    isAdmin() {
      return this.$store.state.userStore.roles.includes("customer_admin");
    },
    userInfo() {
      return this.$store.state.userStore.userInfo;
    },
    subdialogvis() {
      return this.$store.state.userStore.packageInfo.isMember;
    },
  },
  components: {
    top,
  },
  methods: {
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success("复制成功");
      } catch (err) {
        this.$message.error("复制失败");
      }
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getMemberList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getMemberList();
    },
    getMemberList(val) {
      this.loading = true;
      if (val == 1) {
        this.queryParams.pageNum = 1;
      }
      this.$http({
        url: "/customer/teamList",
        method: "POST",
        data: this.queryParams,
      })
        .then((res) => {
          // 负责人(roleId==0)排最上面，其余保持原有相对顺序
          this.memberList = (res.rows || []).slice().sort((a, b) => (a.roleId === 0 ? 0 : 1) - (b.roleId === 0 ? 0 : 1));
          this.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onInviteMember() {
      this.formInvite.targetUser = "";
      this.isInvite = true;
    },
    ok() {
      this.$refs["InviteMember"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm("你确定要发送邀请吗?, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$http({
            url: "/customer/inviteByEmail",
            method: "POST",
            data: this.formInvite,
          }).then(() => {
            this.isInvite = false;
            this.$message({
              type: "success",
              message: "发送成功!",
            });
          });
        });
      });
    },
    handleUpdate(row) {
      this.$http({
        url: "/customer/issue",
        method: "POST",
        data: {
          userId: row.userId,
          ref: true,
        },
      }).then(() => {
        this.$store.dispatch("loadChannel");
        this.getMemberList();
        this.$message({
          type: "success",
          message: "成功!",
        });
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将删除该成员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http.post(`/customer/teamDel/${row.userId}`).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getMemberList();
        });
      })
    },
    // 负责人修改团队成员名称
    onRename(row) {
      this.renameForm = { userId: row.userId, nickName: row.nickName };
      this.renameVisible = true;
    },
    submitRename() {
      this.$refs["renameForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$http({
          url: "/customer/updateMemberName",
          method: "POST",
          data: {
            userId: this.renameForm.userId,
            nickName: this.renameForm.nickName,
          },
        }).then(() => {
          this.renameVisible = false;
          this.$message.success("修改成功");
          this.getMemberList();
        });
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.contents {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.member-list {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  flex-shrink: 0;
}

.search_l {
  display: flex;
  justify-content: flex-start;
  width: 60%;
}

.search_r {
  width: 30%;
}

.table_box {
  width: 99%;
  height: 100%;
}

.table-pagination {
  flex-shrink: 0;
  text-align: right;
  padding-top: 20px;
}

.topInvite {
  text-align: right;
  cursor: pointer;
}

.link-box {
  display: flex;
  align-items: center;

  .link {
    width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #1677ff;
    cursor: pointer;
  }

  .link-copy {
    cursor: pointer;
    margin-left: 10px;
  }

  .link-copy:hover {
    color: #1677ff;
  }
}

::v-deep .el-link{
  margin-right: 10px;
}

.member-name-cell {
  display: flex;
  align-items: center;
}

.member-name-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.edit-name-icon {
  flex-shrink: 0;
  margin-left: 6px;
  color: #1677ff;
  cursor: pointer;
}

.edit-name-icon:hover {
  opacity: 0.7;
}
</style>
